import React, { FC, useContext } from "react";
import styled, { ThemeContext } from "styled-components";
import { colors } from "../../styles/variables";

const StyledSvg = styled.svg`
  &.upsideDown {
    transform: rotate(180deg);
  }
`;

interface CaretIconSvgProps extends React.SVGProps<SVGSVGElement> {
  upsideDown?: boolean;
}

export const CaretIconSvg: FC<CaretIconSvgProps> = ({ upsideDown }) => {
  const theme = useContext(ThemeContext);

  return (
    <StyledSvg
      className={upsideDown ? "upsideDown" : ""}
      width="14"
      height="9"
      viewBox="0 0 14 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5 2L7 7.5L13 1.5"
        stroke={theme.typography.body?.color || colors.darkGray}
        strokeWidth="2"
      />
    </StyledSvg>
  );
};
